module.exports = __webpack_public_path__ + "35517eeb612b14415bc87ed5e1bf1d08.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-10@2x.png
// module id = 494
// module chunks = 0